
import ProductDescriptionItem from '@/components/ProductDescriptionItem.vue'
export default {
  name: 'ProductDescription',
  components: { ProductDescriptionItem },
  props: {
    product: Object,
  },
  computed: {
    renderIncludedVehicles() {
      const vehicles = this.product?.vehicles_included
      if (!vehicles?.length) return ''
      const items = vehicles.map(vehicle =>
        this.$t('components.productDescription.vehicleWithDates', {
          brand: vehicle.brand.name,
          model: vehicle.name,
          dates: this.renderDatesVehicles(vehicle),
        })
      )
      if (items.length === 1) return items[0]
      const last = items.pop()
      return items.join(', ') + ' ' + this.$t('components.productDescription.and') + ' ' + last
    },
    renderParagraph() {
      return (
        this.product.vehicles_included?.length &&
        this.product.variant?.variant_type?.identifier === 'pack' &&
        this.product.variant?.variants_items?.length &&
        this.product.variant?.lumens &&
        this.product.variant?.luminosity_gain &&
        this.product.headlight_types?.length &&
        this.product.headlight_categories?.length &&
        this.product.headlight_types?.length
      )
    },
    renderHeadlightTypes() {
      let value = ''
      this.product.headlight_types?.forEach((item, i) => {
        value += `${item.name}${
          i === this.product.headlight_types.length - 2
            ? ` ${this.$t('components.productDescription.and')} `
            : i === this.product.headlight_types.length - 1
            ? ''
            : `, ${this.$t('components.productDescription.the')} `
        }`
      })
      return value.toLowerCase()
    },

    renderHeadlightCategories() {
      let value = ''
      this.product.headlight_categories?.forEach((item, i) => {
        value += `${item.name}${
          i === this.product.headlight_categories.length - 2
            ? ` ${this.$t('components.productDescription.and')} `
            : i === this.product.headlight_categories.length - 1
            ? ''
            : ', '
        }`
      })
      return value
    },
    renderLumens() {
      return this.product.variant.lumens
    },
    renderLuminosityGain() {
      return this.product.variant.luminosity_gain
    },
  },
  methods: {
    renderDatesVehicles(vehicle) {
      if (vehicle.year_from === vehicle.year_to || vehicle.year_to === null) {
        return this.$t('components.productDescription.fromYear', {
          yearFrom: vehicle.year_from,
        })
      } else {
        return this.$t('components.productDescription.betweenYears', {
          yearFrom: vehicle.year_from,
          yearTo: vehicle.year_to,
        })
      }
    },
  },
}
